
import Vue from "vue";
import { LegalLinks } from "@/Commons/models/responses/LegalLinks";
import { SharedService } from "@/Commons/services/SharedService";
export default Vue.extend({
  props: {
    silentRefreshUrl: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      legalLinks: null as LegalLinks | null
    };
  },
  created() {
    SharedService.getLegalLinks()
      .then(links => {
        this.legalLinks = links;
      })
      .catch(() => {
        console.error("Impossible de récupérer les liens légaux");
      });
  }
});
